module.exports = __webpack_public_path__ + "img/qiguiren.cba2603e.png";